import { useCallback } from "react";

import moment from "../../Moment";
import {
  PassageFormError,
  EventChange,
  PassageState,
} from "../../interfaces/passage";

interface useChangingInterface {
  setFormError: (e: any) => any;
  setState: (e: any) => any;
}

const useChanging = ({ setFormError, setState }: useChangingInterface) => {
  const onIonChange = useCallback(
    (e: EventChange) => {
      const { value, name } = e.detail;
      if (name === "date" && value !== null) {
        setFormError((prevFormError: PassageFormError) => ({
          ...prevFormError,
          [name]: false,
          hour: true,
          minutes: true,
          car_id: true,
        }));

        return setState((prevState: PassageState) => ({
          ...prevState,
          form: {
            ...prevState.form,
            hour: "",
            minutes: "",
            [name]: moment(value).format("YYYY-MM-DD"),
          },
        }));
      }
      if (name !== "observation") {
        setFormError((prevFormError: PassageFormError) => ({
          ...prevFormError,
          [name]: value === "" || value === "0",
        }));
      }

      return setState((prevState: PassageState) => ({
        ...prevState,
        form: {
          ...prevState.form,
          [name]: value,
        },
      }));
    },
    [setFormError, setState]
  );

  return { onIonChange };
};

export default useChanging;
